import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Equipment } from 'modules/Equipment/Equipment'
import { QrCode } from 'modules/QrCode/QrCode'
import { Site } from 'modules/Site/Site'
import { Transaction } from 'modules/Transaction/Transaction'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class Client extends Model {
  static override entity = 'clients'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare client_number: number
  @Attr(null) declare name: string
  @Attr(null) declare description: string | null
  @Attr(null) declare location: string | null
  @Attr(null) declare address: string | null
  @Attr(true) declare is_active: boolean
  @Attr(false) declare default_client: boolean

  @HasMany(() => Equipment, 'equipment_id') declare equipments: Equipment[]
  @HasMany(() => QrCode, 'qr_code_id') declare qrCodes: QrCode[]
  @HasMany(() => Site, 'site_id') declare sites: Site[]
  @HasMany(() => Transaction, 'transaction_id') declare transactions: Transaction[]

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
